export type MedcallLatestRequestGuard = {
  begin: () => number;
  invalidate: () => void;
  isLatest: (requestId: number) => boolean;
};

export const createMedcallLatestRequestGuard = (): MedcallLatestRequestGuard => {
  let latestRequestId = 0;

  return {
    begin: () => {
      latestRequestId += 1;
      return latestRequestId;
    },
    invalidate: () => {
      latestRequestId += 1;
    },
    isLatest: (requestId) => requestId === latestRequestId,
  };
};
